// Droite
// Attendre que le DOM soit complètement chargé
document.addEventListener("DOMContentLoaded", () => {
  const fromRight = document.getElementById("fromRight");

  // Vérifier que l'élément existe avant de procéder
  if (fromRight) {
    // Réinitialiser l'état de l'image (cachée à droite)
    fromRight.style.opacity = 0;
    fromRight.style.transform = "translateX(100%)"; // Commence à droite de l'écran
    fromRight.style.transition = "none"; // Supprimer toute transition pendant la réinitialisation

    // Forcer le reflow (ce qui réinitialise l'élément)
    void fromRight.offsetWidth;

    // Appliquer les transitions après un délai pour éviter que tout se fasse instantanément
    setTimeout(() => {
      // Relancer la transition
      fromRight.style.transition = "opacity 2s ease, transform 2s ease"; // Transition plus lente
      fromRight.style.opacity = 1;
      fromRight.style.transform = "translateX(0)"; // Déplacer l'élément à sa position normale
    }, 10); // Légèrement après pour éviter que tout soit trop instantané
  }
});

// Utiliser IntersectionObserver pour observer l'élément lorsqu'il devient visible
window.addEventListener("DOMContentLoaded", () => {
  const fromRight = document.getElementById("fromRight");

  // Vérifier que l'élément existe avant de procéder
  if (fromRight) {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // L'élément est visible dans la fenêtre de vue
            entry.target.style.opacity = 1;
            entry.target.style.transform = "translateX(0)";
            observer.unobserve(entry.target); // Arrêter d'observer une fois l'animation commencée
          }
        });
      },
      {
        threshold: 0.5, // 50% de l'élément doit être visible
      }
    );

    observer.observe(fromRight); // Commencer à observer l'élément
  }
});

// Gauche
// Fonction pour faire apparaître l'élément depuis la gauche
function fromLeft(elementId) {
  const element = document.getElementById(elementId);

  // Vérifier que l'élément existe
  if (element) {
    // Initialiser l'état de l'image (cachée à gauche)
    element.style.opacity = 0;
    element.style.transform = "translateX(-100%)"; // L'image commence à gauche
    element.style.transition = "opacity 1s ease, transform 1s ease";

    // Observer l'élément
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          // Vérifie si l'élément est visible
          if (entry.isIntersecting) {
            // Appliquer l'animation lorsque l'élément devient visible
            entry.target.style.opacity = 1;
            entry.target.style.transform = "translateX(0)"; // L'image se déplace à sa position normale

            // Déclenche l'animation une seule fois et arrête l'observation
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.5, // 50% de l'élément doit être visible
      }
    );

    // Commencer à observer l'élément
    observer.observe(element);
  }
}

// Attendre que le DOM soit complètement chargé
document.addEventListener("DOMContentLoaded", () => {
  // Appeler la fonction fromLeft sur l'élément avec id 'fromLeft'
  fromLeft("fromLeft");
});
